<template>
  <v-app>
    <v-content>
      <v-container>
        <v-card
          class="mx-auto pa-2 mb-4 text-center"
          flat
          max-width="600"
        >
          <v-form
            class="my-6"
            ref="form"
            @submit.prevent="submit"
          >
            <v-row no-gutters>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  label="Enter an URL"
                  v-model="url"
                  required
                  outlined
                  :rules="[rules.required, rules.url]"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <div
                  class="ml-4"
                  style="max-width: 240px"
                >
                  <v-select
                    v-model="lang"
                    item-value="value"
                    item-text="text"
                    label="Language"
                    required
                    outlined
                    hide-details
                    :rules="[rules.required]"
                    :items="languages"
                  />
                </div>
              </v-col>
            </v-row>
            <div class="d-flex justify-center align-items-center">
              <v-btn
                color="primary"
                type="submit"
                class="mr-2"
              >
                Check Keyword Frequency
              </v-btn>
              <CopyButton :content="copyableContent" />
            </div>
          </v-form>
        </v-card>


        <ErrorAlert
          :error="error"
        />

        <TopicList
          class="max-width mx-auto"
          v-if="result"
          :items="result.topics"
          show-all
        />
      </v-container>

      <LoadingOverlay v-if="loading" />
    </v-content>
  </v-app>
</template>

<script>
import validationRules from '../validation-rules.js'
import { extractTopics } from '../services/api'
import ErrorAlert from '@/components/ErrorAlert.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import TopicList from '@/components/TopicList.vue'
import languages from '../languages.json'
import CopyButton from '@/components/CopyButton.vue';


export default {
  name: 'ExtractTopics',
  components: { ErrorAlert, LoadingOverlay, TopicList, CopyButton },
  data: () => ({
    loading: false,
    url: null,
    result: null,
    error: null,
    rules: validationRules,
    lang: 'en',
    languages,

  }),
  computed: {
    copyableContent() {
      if (this.result?.topics) {
        return this.result.topics.map(({ topic }) => topic).join('\n')
      }

      return ''
    }
  },
  methods: {
    async submit() {
      this.error = null
      this.result = null

      if (this.$refs.form.validate()) {
        // this.loading = true

        try {
          const { data } = await extractTopics({ url: this.url, lang: this.lang })
          this.result = {
            topics: data.kwBody.map(({ term, tf }) => ({ topic: term, tf }))
          }
        } catch (error) {
          this.error = error
        } finally {
          this.loading = false
        }
      }
    }
  },
}
</script>

<style scoped>
.max-width {
  max-width: 500px;
}
</style>

<style>
.v-application--wrap {
  min-height: auto;
}
</style>
